<template>
    <div class="report-details" style="padding-bottom: 210px;">
        <div v-for="(item, index) in cardList" :key="index">
            <div v-if="index" class="line"></div>
            <div class="card">
                <img v-if="item.isStatusImg" class="status-img" :src="`https://staticwecom.beautyfarm.com.cn/20251230/status${info.reportStatus}.png`" alt="">
                <div class="card-hd">
                    <img :src="`https://staticwecom.beautyfarm.com.cn/20251230/${item.icon}.png`" alt="">
                    <div>{{ item.title }}</div>
                </div>
                <div v-for="(it, i) in item.items" :key="i">
                    <div class="card-item" v-if="it.prop !== 'reviewDes' || (it.prop === 'reviewDes' && info.reportStatus === 5)">
                        <div class="card-label">{{ it.label }}</div>
                        <div class="card-value" :class="{ red: it.prop === 'reviewDes' }">{{ info[it.prop] }}</div>
                    </div>
                </div>

                <div v-if="item.isFlies">
                    <div class="file-list" v-for="(it, i) in info.fileUrls" :key="i" @click="onViewFile(it)">
                        <img v-if="isImageFile(it)" class="file-img" :src="it">
                        <van-icon v-else size="62" name="orders-o" />
                        <div class="file-info">
                            {{ getFileName(it) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ft-btn" v-if="postClassifyCode == '10' && info.reportStatus === 2">
            <div class="btns">
                <div class="btn approve" @click="onReject(3)">通过</div>
                <div class="btn reject" @click="onReject(5)">驳回</div>
            </div>
        </div>

        <van-popup v-model="showRejectReasonPopup" round closeable>
            <div class="popup-main">
                <div class="popup-title">审核理由</div>
                <van-field v-model="reviewDes" type="textarea" placeholder="请输入理由" :maxlength="50" rows="4" show-word-limit />
                <div class="popup-btn">
                    <div class="btn-primary warn" @click="showRejectReasonPopup = false">取消</div>
                    <div class="btn-primary" @click="onConfirmRejectReason">提交</div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import { getReportDetails, reportUpdateStatus } from '@/api/crm'
    import { ImagePreview } from 'vant'
    import { getUserLogin } from '@/api/home'
    import { throttle } from 'lodash';

    export default {
        name: 'ReportDetails',
        data() {
            return {
                // 报告详情页面展示的卡片列表
                cardList: [
                    {
                        title: '基本信息', // 卡片标题
                        icon: 'icon1',   // 图标名
                        isStatusImg: true, // 是否显示状态图片
                        items: [
                            { label: '门店编码', prop: 'storeNo' },     // 门店编码
                            { label: '门店名称', prop: 'storeName' },   // 门店名称
                            { label: '申请时间', prop: 'createDate' }, // 申请时间
                            { label: '原因', prop: 'reviewDes' },  // 驳回原因
                        ]
                    },
                    {
                        title: '报备信息',
                        icon: 'icon2',
                        items: [
                            { label: '报备类型', prop: 'reportTypeStr' },    // 报备类型
                            { label: '生效时间', prop: 'validPeriod' },   // 生效时间（有效期）
                            { label: '报备说明', prop: 'reportDes' },    // 报备说明
                        ]
                    },
                    {
                        title: '证明材料',
                        icon: 'icon3',
                        isFlies: true // 是否为材料（有文件列表）
                    }
                ],
                info: {},                       // 存储报告的详细信息
                showRejectReasonPopup: false,   // 控制驳回理由弹窗的显示
                reviewDes: '',                  // 驳回理由内容
                id: '',                        // 当前报告的ID
                // 岗位类型1-主任，2-美疗师，3-技术监理，4-客户经理，5-区经，6-医美销售岗，7-医美销售经理，8-医美销售主任,9-质控专员,10-质控经理
                postClassifyCode: '',
                reportStatus: 3,
                // 报告状态3-通过，5-驳回
            }
        },
        async created() {
            this.id = this.$route.query.id
            this.getInfo()

            const { data } = await getUserLogin()
            this.postClassifyCode = data.postClassifyCode
        },
        methods: {
            // 获取报备详情信息
            async getInfo() {
                try {
                    const { code, data, msg } = await getReportDetails(this.id)
                    if (code !== 0) throw msg

                    this.info = data
                    this.info.validPeriod = data.startDate + ' 至 ' + data.endDate
                } catch (error) {
                    this.$toast(error + '')
                }
            },
            onApprove: throttle(async function (reportStatus = 3) {
                try {
                    // if (reportStatus === 5 && !this.reviewDes) {
                    //     throw '驳回理由必填'
                    // }
                    const req = {
                        id: this.id,
                        reviewDes: this.reviewDes || '',
                        reportStatus
                    }
                    const { code, msg } = await reportUpdateStatus(req)
                    if (code !== 0) throw msg

                    this.$toast('操作成功')
                    this.showRejectReasonPopup = false

                    setTimeout(() => {
                        const path = this.postClassifyCode === '1' ? '/CRM/report' : '/CRM/inspectStore?activeName=records&storeId=' + this.info.storeNo
                        this.$router.replace(path)
                    }, 500);

                } catch (error) {
                    this.$toast(error + '')
                }
            }, 2000),
            onReject(reportStatus) {
                this.reviewDes = ''
                this.reportStatus = reportStatus
                this.showRejectReasonPopup = true
            },

            // 驳回理由弹窗确认
            onConfirmRejectReason() {
                this.onApprove(this.reportStatus)
            },

            // 查看图片预览
            imagePreview(url) {
                ImagePreview({
                    images: [url],
                    closeable: true,
                    closeIcon: 'close',
                })
            },
            // 获取文件名
            getFileName(url) {
                return url.split('/').pop() || ''
            },
            // 查看文件（如果是图片则预览，否则新窗口打开）
            onViewFile(url) {
                if (this.isImageFile(url)) {
                    this.imagePreview(url)
                } else {
                    window.open(url, '_blank')
                }
            },
            // 判断文件是否为图片类型
            isImageFile(url) {
                // 获取文件扩展名
                const extension = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
                // 支持的图片扩展名列表
                const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
                // 判断当前文件扩展名是否为图片扩展名
                return imageExtensions.includes(extension);
            }
        }
    }
</script>

<style lang='less' scoped>
    .report-details {
        height: 100%;
        font-size: 28px;
        color: #35434c;
        background-color: #fff;
        overflow-y: scroll;
    }

    .card {
        position: relative;
        padding: 30px;
        // margin-bottom: 20px;
    }

    .card-hd {
        display: flex;
        align-items: center;
        font-size: 34px;
        font-weight: 500;

        >img {
            width: 40px;
            height: 40px;
            margin-right: 4px;
        }
    }

    .status-img {
        position: absolute;
        width: 204px;
        height: 204px;
        top: 30px;
        right: 30px;
    }

    .card-item {
        display: flex;
        margin-top: 30px;

        .card-label {
            width: 140px;
            color: #A0ACB5;
        }

        .card-value {
            flex: 1;
        }
    }

    .line {
        height: 20px;
        background-color: #F9FAFC;
    }

    .red {
        color: #F65252;
    }

    .ft-btn {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 180px;
        padding: 40px 100px 50px;
        background-color: #fff;


        .btns {
            display: flex;
            justify-content: space-between;
        }

        .btn {
            width: 250px;
            height: 90px;
            line-height: 90px;
            text-align: center;
            color: #fff;
            background-color: #333F48;
            border-radius: 90px;
        }

        .reject {
            background-color: #2FD0D5;
        }
    }

    .file-list {
        display: flex;
        align-items: center;
        padding: 24px;
        margin-top: 30px;
        font-size: 28px;
        border: 2px solid #e0e0e0;
        border-radius: 12px;
        cursor: pointer;

        .file-img {
            width: 62PX;
            height: 62PX;
        }

        .file-info {
            flex: 1;
            padding-left: 24px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }

    .popup-main {
        width: 600px;
        padding: 40px;

        .popup-title {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 30px;
        }

        .popup-btn {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
        }

        .btn-primary {
            width: 230px;
            height: 80px;
            line-height: 80px;
            text-align: center;
            color: #fff;
            background-color: #2FD0D5;
            border-radius: 80px;

            &.warn {
                color: #333F48;
                background-color: #fff;
                border: 2px solid #333F48;
            }
        }
    }

</style>

<style lang='less'>
    .report-details {
        .van-field {
            background-color: #F2F2F5;
        }
    }
</style>
